import { isEmpty, isNumber } from "./validationUtil";

/**
 *      const leavePlanBody = {
            memberId: memberId,
            reason: leavePlanReason,
            startDate: getDateInFormat(leavePlanStartDate),
            endDate: getDateInFormat(leavePlanEndDate),
            status: AppConstants.DEFAULT_LEAVE_PLAN_STATUS,
            type: AppConstants.DEFAULT_LEAVE_PLAN_TYPE,
        };
 * @param {*} leavePlanObject 
 */
export const validateLeavePlanObject = (leavePlanObject) => {
    // Polymorphic owner (mirrors activities): manager self-leave (isMember === false) is keyed by
    // managerId; member leave is keyed by memberId.
    const isManagerLeave = leavePlanObject.isMember === false;
    var isValid = isManagerLeave
        ? (isNumber(leavePlanObject.managerId) && leavePlanObject.managerId > 0)
        : (isNumber(leavePlanObject.memberId) && leavePlanObject.memberId > 0);
    isValid = isValid && leavePlanObject.hasOwnProperty("reason") && isValidReason(leavePlanObject.reason);
    isValid = isValid && leavePlanObject.hasOwnProperty("startDate") && leavePlanObject.hasOwnProperty("endDate") && isValidLeavePlanDates(leavePlanObject.startDate, leavePlanObject.endDate);

    return isValid;
    // Field value validation
}

export const isValidLeavePlanDates = (startDate, endDate) => {
    try {
        if(!isEmpty(startDate) && !isEmpty(endDate)) {
            let date1 = new Date(startDate).getTime();
            let date2 = new Date(endDate).getTime();
            return (date2 >= date1);
        }
        else {
            return false;
        }
    } catch(err) {
        return false;
    }
}
// Description can't be empty and less than 255 characters
export const isValidReason = (reason) => {
    if(!isEmpty(reason) && reason.length > 1 && reason.length < 255) {
        return true;
    }
    else {
        return false;
    }
}
